import axios from "axios";

const API_URL = `${process.env.REACT_APP_API_URL}/rdvfinance`;


// ======================================================
// GET toutes les finances
// ======================================================
export const getFinances = async () => {

    const response = await axios.get(API_URL);

    return response.data;
};


// ======================================================
// GET finance par ID
// ======================================================
export const getFinanceById = async (id) => {

    const response = await axios.get(
        `${API_URL}/${id}`
    );

    return response.data;
};


// ======================================================
// GET finance par rendez-vous
// ======================================================
export const getFinanceByRendezVous = async (rendezVousId) => {

    const response = await axios.get(
        `${API_URL}/rendez-vous/${rendezVousId}`
    );

    return response.data;
};


// ======================================================
// CREATE finance
// ======================================================
export const createFinance = async (data) => {

    const response = await axios.post(
        API_URL,
        data
    );

    return response.data;
};


// ======================================================
// UPDATE finance
// ======================================================
export const updateFinance = async (id, data) => {

    const response = await axios.put(
        `${API_URL}/${id}`,
        data
    );

    return response.data;
};


// ======================================================
// DELETE finance
// ======================================================
export const deleteFinance = async (id) => {

    const response = await axios.delete(
        `${API_URL}/${id}`
    );

    return response.data;
};